import wrapError from "@/components/helpers/wrapError"

export const apiGetRoleDataHealth = (success, error) => {
  $.ajax({
    type: "GET",
    url: "/api/volunteer/roleDataHealth",
    success,
    error: wrapError(error, "apiGetRoleDataHealth"),
  })
}
